import { useCallback } from 'react';
import { useLazyGetOmniSpeakToTextsQuery } from 'services';
import { CallSessionDto, FindAllSpeakToTextDto } from 'types';
import { MESSAGE_LIMIT_LOAD, OMNI_MESSAGE_QUERY_TYPE } from 'utils';
const limit = MESSAGE_LIMIT_LOAD;
export function useLazyOmniSpeakToTexts(
  callSession: CallSessionDto,
  params?: Partial<Omit<FindAllSpeakToTextDto, 'limit' | 'keyword' | 'pageIndex' | 'pageSize' | 'skip'>>
) {
  const [trigger, { data: dataResponse, isLoading, isFetching, originalArgs, endpointName }] =
    useLazyGetOmniSpeakToTextsQuery({
      refetchOnReconnect: true
    });

  const originalArgsParams = {
    ...originalArgs,
    ...params
  };

  const { rows, count } = dataResponse?.data || {};
  const hasMore = Boolean(rows && count && rows.length < count);
  const endMessage = rows && rows[rows.length - 1];
  const hasNew = useCallback(
    () =>
      endMessage?.speakToTextId
        ? endMessage?.callSessionId === callSession.callSessionId &&
          endMessage?.speakToTextId !== callSession.lastSpeakToTextId
        : false,
    [callSession, endMessage]
  )();

  const getOlderMess = useCallback(
    (value?: Partial<FindAllSpeakToTextDto>) => {
      return trigger({
        ...(originalArgsParams as FindAllSpeakToTextDto),
        limit,
        skip: 0,
        sortOrder: OMNI_MESSAGE_QUERY_TYPE.OLDER,
        // message: undefined,
        startMessageId: rows?.[0]?.speakToTextId,
        ...value
      });
    },
    [hasMore, originalArgsParams, rows]
  );

  const getNewerMess = useCallback(
    (value?: Partial<FindAllSpeakToTextDto>) => {
      return trigger({
        ...(originalArgsParams as FindAllSpeakToTextDto),
        limit,
        skip: 0,
        sortOrder: OMNI_MESSAGE_QUERY_TYPE.NEWER,
        // message: undefined,
        startMessageId: rows?.[rows.length - 1]?.speakToTextId,
        ...value
      });
    },
    [hasMore, originalArgsParams, rows]
  );

  const fetchData = useCallback(
    (value: FindAllSpeakToTextDto) => {
      return trigger({
        ...originalArgsParams,
        limit,
        skip: 0,
        sortOrder: undefined,
        // message: undefined,
        ...value
      });
    },
    [trigger]
  );
  return {
    data: rows || [],
    count: count || 0,
    isLoading: isLoading,
    hasMore,
    hasNew,
    fetchData,
    getOlderMess,
    isFetching: isFetching,
    originalArgs: originalArgsParams,
    endpointName,
    getNewerMess
  };
}
